module.exports = __webpack_public_path__ + "static/media/MobileAir.419b6c9b.png";